import {
    WithProfileId,
    isEnterpriseProfileData,
    isIntegrationProfileData,
    isPersonalProfileData,
} from '@mews-commander/types';
import ViaIntegration from '../ViaIntegration';
import { useProfileData } from '../../useProfileData';
import UserEmail from './UserEmail';

const MemberProfileDetail: React.FC<WithProfileId> = ({ profileId }) => {
    const profileData = useProfileData(profileId);

    if (!profileData) {
        return null;
    }

    if (isEnterpriseProfileData(profileData) || isPersonalProfileData(profileData)) {
        return <UserEmail userId={profileData.value.userId} />;
    }

    if (isIntegrationProfileData(profileData)) {
        return <ViaIntegration integrationId={profileData.value.integrationId} />;
    }

    return null;
};

export default MemberProfileDetail;
